var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatteryFailure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Battery failure ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Battery-failure-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3746163,7.22380801 L12.3746163,6.91828511 C12.3746163,6.41279919 11.9553548,6 11.4378563,6 L3.93675993,6 C3.41926147,6 3,6.41279919 3,6.91828511 L3,9.67056581 C3,10.1760517 3.41926147,10.5871345 3.93675993,10.5871345 L11.4378563,10.5871345 C11.9553548,10.5871345 12.3746163,10.1760517 12.3746163,9.67056581 L12.3746163,9.36418471 L13,9.36418471 L13,7.22380801 L12.3746163,7.22380801 Z M11.7492325,9.67056581 L11.7492325,9.67056581 C11.7492325,9.83963326 11.6106482,9.97608871 11.4378563,9.97608871 L9.2494518,9.97608871 L9.2494518,6.61276221 L11.4378563,6.61276221 C11.6106482,6.61276221 11.7492325,6.74921767 11.7492325,6.91828511 L11.7492325,9.67056581 Z",
    id: "Fill-13",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryFailure);
export default __webpack_public_path__ + "static/media/Battery_failure.eba13616.svg";
export { ForwardRef as ReactComponent };